/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
---------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from "vue";
// Vue.js filter for formatting numbers. This is a simple wrapper for Numeral.js.
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
 
import appConfig from '@/../appConfig.js';
import { appCommons } from '@/app/shared/services';

const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
    }
    else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages     = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp                 = false
    let lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited    = state.starredPages.slice(0, 10)
    state.starredPages           = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay       = val },
  UPDATE_PRIMARY_COLOR(state, val)   { state.themePrimaryColor = val },
  UPDATE_THEME(state, val)           { state.theme             = val },
  UPDATE_WINDOW_WIDTH(state, width)  { state.windowWidth       = width },
  UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY = val },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO(state, payload) {

    // Get Data localStorage
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser

    for (const property of Object.keys(payload)) {

      if (payload[property] != null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.AppActiveUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]
      }


    }
    // Store data in localStorage
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    mapScopeIdentity();
  },


/******************************************************************************
 * 
 * APPYVUE CUSTOMIZATION - START
 * 
******************************************************************************/
  // /////////////////////////////////////////////
  // AppConf Definition
  // /////////////////////////////////////////////

  // Updates App Conf in state and localstorage
  UPDATE_APP_CONF(state, payload) {

    // Get Data localStorage
    let appConf = JSON.parse(localStorage.getItem('app.conf')) || state.AppConf

    for (const property of Object.keys(payload.query)) {

      if (payload.query[property] != null) {
        // If some of conf property is null - use default property defined in state.AppConf
        // Vue.set(state.AppConf, property, payload.query[property]);
        state.AppConf[property] = payload.query[property];
        state.AppConfTrack = Math.random();

        // Update key in localStorage
        appConf[property] = payload.query[property]
      }


    }

    // Store data in localStorage
    localStorage.setItem('app.conf', JSON.stringify(appConf))
  },
  // /////////////////////////////////////////////
  // Scope Definition
  // /////////////////////////////////////////////

  // Updates App Scope in state and localstorage
  UPDATE_APP_SCOPE(state, payload) {

    // Get Data localStorage
    let appScope = JSON.parse(localStorage.getItem('app.scope')) || state.AppScope

    for (const property of Object.keys(payload.query)) {

      if (payload.query[property] != null) {
        // If some of scope property is null - use default property defined in state.AppScope
        // Vue.set(state.AppScope, property, payload.query[property]);
        state.AppScope[property] = payload.query[property];
        state.AppScopeTrack = Math.random();

        // Update key in localStorage
        appScope[property] = payload.query[property]
      }


    }

    // Store data in localStorage
    localStorage.setItem('app.scope', JSON.stringify(appScope))

    mapScopeIdentity();
  },
 
}

const mapScopeIdentity = () => {
  
  let currentScope = appCommons.currentScope();
  let localeToUse = appCommons.scopeLocale();

  if(localeToUse) {
    // // switch between locales
    numeral.locale(localeToUse);

    Vue.filter('numFormat', numFormat(numeral));

    Vue.filter('currencySymbol', function (value) {

      return value +' '+ appConfig.common.numerals[localeToUse].currency.symbol;
    });  
  }

  if(currentScope && currentScope.length > 0) {
    localStorage.setItem("app.scope.identity", currentScope[0]);
  }  
}

/******************************************************************************
 * 
 * APPYVUE CUSTOMIZATION - END
 * 
******************************************************************************/ 

export default mutations

